import React from "react";
import filterContext from "./filterContext";
import { useState, useEffect } from "react";
import filteredChats from "../../components/filteredChats";
// import { startsWith } from 'lodash';
// import { log } from 'winston';
import { notification } from "antd";
import { data } from "autoprefixer";
import { useRef } from "react";
import { useSelector } from "react-redux";
// import getSocketInstance from 'routes/chats/pages/socket';
import getSocketInstance from "../../pages/socket";
import convertS3ToCloudFront from "../../../../../../utils/convertS3ToCloudFront";
// import { selectedPhaseIdSelector } from 'selectors/user';
import { UseSelector } from "react-redux";
const FilterState = (props) => {
  useEffect(() => {
    const socket = getSocketInstance();
  }, []);
  let userId = useSelector((state) => state.user._id);
  // Base Url
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const phaseId = window?.config?.phaseId;
  const user = useSelector((state) => state.user);
  const clientSelector = (state) => state.api.Client;
  const subscriptions = user.subscriptions;
  function getActivePhaseId(data) {
    // Assuming data is an array with the given structure
    for (const group of data) {
      for (const subgroup of group.subgroups) {
        for (const phase of subgroup.phases) {
          if (phase.active) {
            return phase.phase._id;
          }
        }
      }
    }
    // Return null or handle the case when no active phase is found
    return null;
  }

  // const clientId = window.config.clientId;
  const clientId = window.config.clientId;
  const chatContainerRef = useRef(null);
  //state for getting th information set by aws
  const [infoMedia, setinfoMedia] = useState({
    acl: "",
    key: "",
    mime: "",
    bucket: "",
  });
  //state for getting text message and image
  const [sampledataa, setsampledataa] = useState("");
  // state for togling between toggle Chat and Filter
  const [tog, settog] = useState(true);
  const [togChat, settogChat] = useState(true);
  const [showRedFlagResolution, setShowRedFlagResolution] = useState(false);

  const [unreadFlag, setUnreadFlag] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupDesc, setGroupDesc] = useState("");
  const [replyId, setReplyId] = useState(null);
  const [replyMsg, setReplyMsg] = useState(null);
  const [flagScroll, setFlagScroll] = useState(false);
  const [staticGetMsg, setstaticGetMsg] = useState([
    {
      msg: "",
    },
  ]);
  const [fileSelect, setfileSelect] = useState("");
  const [imgSent, setimgSent] = useState(false);
  const [msgTexts, setmsgTexts] = useState([]);
  const [imgpdfstatus, setImgpdfStatus] = useState(0);
  const messageTexts = [];
  // state for eact filter start
  //desciption of a particular student
  const [description, setdescription] = useState({});
  const [mediaDetails, setmediaDetails] = useState({
    filename: "s",
    type: "s",
  });
  const [usersOfParticularGroup, setusersOfParticularGroup] = useState({});
  const [displayedUsersOfGroup, setDisplayedUsersOfGroup] = useState([]);
  const [adminsOfParticularGrp, setAdminsOfParticularGrp] = useState([]);
  const [isGrpEdited, setIsGroupEdited] = useState(false);
  const [convId, setconvoId] = useState("");
  const [filter, setfilter] = useState(false);
  const [shortcutId, setShortcutId] = useState("");
  const [readByArray, setReadByArray] = useState([]);
  const [senderId, setSenderId] = useState("");
  const [senderName, setSenderName] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [broadurls, setBroadurls] = useState([]);
  const [selectedReceivedMsgs, setSelectedReceivedMsgs] = useState([]);
  const [isPollMsgSelected, setIsPollMsgSelected] = useState([]);
  const [shortcutConv, setShortcutConv] = useState([]);
  const [createdBy, setCreatedBy] = useState({});
  const [createdAt, setCreatedAt] = useState("");
  const [selectedRedFlagMsgs, setSelectedRedFlagMsgs] = useState([]);
  const [selectedMsgsForForward, setSelectedMsgsForForward] = useState([]);
  const [selectedMsgsForDelete, setSelectedMsgsForDelete] = useState([]);
  const [msgDeleted, setMsgDeleted] = useState(false);
  const [unReadByArray, setUnReadByArray] = useState([]);
  const [inputTextImage, setInputTextImage] = useState("");
  const [olderMessages, setOlderMessages] = useState(true);
  const [activeDropdownMsgId, setActiveDropdownMsgId] = useState(null);
  const [customFilterData, setCustomFilterData] = useState([]);

  //The following state is used for Conversation name which will be set in ChatDetails purpose when we chat a person for the first time
  const [chatSelected, setChatSelected] = useState(null);
  const [standardfilter, setstandardfilter] = useState({
    // '11 Humanities': false,
    // '12 Humanities': false,
    // '12 Science': false,
    // '11 Science': false,
    // '12 Commerce': false,
    // '11 Commerce': false,
    // '10 Science': false,
    // '09 Science': false,
    // '10 Commerce': false,
    // '09 Commerce': false,
    // '10': false,
    // '09': false,
    // '08': false,
    // '07': false,
    // '06': false,
  });
  const [level, setlevel] = useState({
    // level1: false,
    // level2: false,
    // level3: false,
  });
  const [batchfilter, setbatchfilter] = useState({
    // _a2: false,
    // _a: false,
    // _b: false,
    // _b2: false,
    // _c: false,
    // _c2: false,
    // _d: false,
    // _d2: false,
    // _e: false,
    // _f: false,
    // _g: false,
    // _h: false,
    // _m: false,
    // _u: false,
    // A: false,
    // A2: false,
    // B: false,
    // B2: false,
    // C: false,
    // C2: false,
    // 'C-B1': false,
    // 'C-B2': false,
    // 'C-B3': false,
    // 'C-J1': false,
    // 'C-J2': false,
    // 'C-J3': false,
    // 'C-N1': false,
    // 'C-N2': false,
    // 'C-N3': false,
    // D: false,
    // D2: false,
    // E: false,
    // F: false,
    // G: false,
    // H: false,
    // 'I-B1': false,
    // 'I-B2': false,
    // ' I-J/N1': false,
    // 'I-J/N2': false,
    // M: false,
    // 'S-B1': false,
    // 'S-B2': false,
    // 'S-J/N1': false,
    // 'S-J/N2': false,
    // U: false,
  });
  const [branchfilter, setbranchfilter] = useState({
    // 'Parimal Garden': false,
    // Dharnidhar: false,
    // Naranpura: false,
    // Prernatirth: false,
    // 'Aaryan Gloria': false,
    // Navrangpura: false,
    // Sindhubhavan: false,
    // 'Judges Bunglow': false,
    // 'Science City:': false,
    // Vastrapur: false,
    // Prahladnagar: false,
    // 'Judges Bunglow (JEET Division)': false,
    // Ghodasar: false,
    // 'Drive In': false,
    // 'Subhash Chowk': false,
    // Gurukul: false,
    // 'Mansi Circle': false,
    // Bhatta: false,
    // Shela: false,
    // 'Orchid Centre': false,
    // Vaishnodevi: false,
    // Gota: false,
    // 'Anandnagar Road': false,
    // Makarba: false,
    // Maninagar: false,
  });
  const [boardsfilter, setboardsfilter] = useState({
    // CBSE: false,
    // GSEB: false,
    // ICSE: false,
    // ISC: false,
    // IB: false,
    // IGCSE: false,
  });
  const [programFilter, setProgramFilter] = useState({});
  const [schoolFilter, setSchoolFilter] = useState({
    // 'Sattva Vikas School': false,
    // 'Kameshwar Vidyavihar': false,
    // 'H.B.Kapadia (Hbk)': false,
    // 'Nirman Vastrapur': false,
    // "St. Xavier'S High School Loyola Hall": false,
    // 'Oxford English High School': false,
    // 'Dav International School': false,
    // 'Shanti Asiatic School': false,
    // 'Shreyas Foundation': false,
    // 'Delhi Public School - Dps (South Bopal)': false,
    // 'Kendriya Vidhlaya (Sac)': false,
    // 'Maharaja Agrasen Vidyalaya': false,
    // Crescent: false,
    // 'G.L.S.': false,
    // 'The New Tulip International School': false,
    // 'Divya Joyt': false,
    // 'Shree Narayana Guru Vidhyalaya (Sngv)': false,
    // 'Navchetan High School': false,
    // 'Little Flower School': false,
    // 'F.D. School': false,
    // 'Divine Buds School': false,
    // 'St. Xavier Mirzapur': false,
    // 'Divine Life School': false,
    // Sharadamandir: false,
    // 'Zebar School For Children': false,
    // Ankur: false,
    // 'Prakash High School': false,
    // Udgam: false,
    // 'Cosmos Castle International School': false,
    // Zydus: false,
    // 'Sri Sri Ravishankar Vidya Mandir (Ssrvm)': false,
    // "St. Ann'S High School": false,
  });
  const [subjectfilter, setsubjectfilter] = useState({
    // Accountancy: false,
    // 'Applied Mathematics': false,
    // Biology: false,
    // 'Boards-Biology': false,
    // 'Boards-Chemistry': false,
    // 'Boards-Mathematics': false,
    // 'Boards-Physics': false,
    // 'Business Studies': false,
    // 'Centralized NEET-Biology': false,
    // 'Centralized NEET-Chemistry': false,
    // 'Centralized NEET-Physics': false,
    // Chemistry: false,
    // Commerce: false,
    // 'Commercial Studies': false,
    // CST: false,
    // Economics: false,
    // English: false,
    // 'English (C)': false,
    // 'English Grammar': false,
    // 'English Literature': false,
    // Entrepreneurship: false,
    // French: false,
    // Geography: false,
    // History: false,
    // 'History Civics': false,
    // 'Information Practice': false,
    // 'JEE Advanced-Chemistry': false,
    // 'JEE Advanced-Mathematics': false,
    // 'JEE Advanced-Physics': false,
    // 'JEE Mains-Chemistry': false,
    // 'JEE Mains-Mathematics': false,
    // 'JEE Mains-Physics': false,
    // Mathematics: false,
    // 'Morning Session': false,
    // 'NEET-Biology': false,
    // 'NEET-Chemistry': false,
    // 'NEET-Physics': false,
    // 'Organization of Commerce & Management': false,
    // Physics: false,
    // 'Political Science': false,
    // Psychology: false,
    // Python: false,
    // Science: false,
    // 'Social Science': false,
    // 'Social Science (C)': false,
    // Statistics: false,
  });

  function resetAllFilter() {
    var updatedFilters = {};
    if (checked.timeOpt != 0) {
      setchecked({ timeOpt: 0 });
    }
    setnameOfdate({
      date: "",
      toDate: "",
      fromDate: "",
    });
    setSelectedDate("");
    for (const key in batchfilter) {
      updatedFilters[key] = false;
    }
    setbatchfilter(updatedFilters);
    for (const key in subjectfilter) {
      updatedFilters[key] = false;
    }
    setsubjectfilter(updatedFilters);
    for (const key in schoolFilter) {
      updatedFilters[key] = false;
    }
    setSchoolFilter(updatedFilters);

    for (const key in boardsfilter) {
      updatedFilters[key] = false;
    }
    setboardsfilter(updatedFilters);
    for (const key in branchfilter) {
      updatedFilters[key] = false;
    }
    setbranchfilter(updatedFilters);
    for (const key in level) {
      updatedFilters[key] = false;
    }
    setlevel(updatedFilters);
    for (const key in standardfilter) {
      updatedFilters[key] = false;
    }
    setstandardfilter(updatedFilters);
  }
  const [reloadFlag, setReloadFlag] = useState(false);
  // state for each filter end
  // from here starting context for API
  const [getMsg, setgetMsg] = useState(null);
  const [sender_id, setsender_id] = useState("");
  const [conversationdata, setConversationdata] = useState([]);
  const [selectedConversations, setSelectedConversations] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedMsgs, setSelectedMsgs] = useState([]);
  const [broadcastMsg, setBroadcastMsg] = useState("");
  const [customFilterName, setCustomFilterName] = useState("");
  const [customFilterShortName, setCustomFilterShortName] = useState("");
  const [customShortcutData, setCustomShortcutdata] = useState([]);
  const [forwardCheckbox, setForwardCheckbox] = useState(false);
  const [pstate, setpstate] = useState(false);
  const [pdfFileName, setpdfFileName] = useState([]);
  const [showPopupClip, setShowPopupClip] = useState(false);
  //state for selectedfile and url
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isSend, setIsSend] = useState(false);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [isSocketReceived, setIsSocketReceived] = useState(false);
  const [previewMedia, setPreviewMedia] = useState([]);

  const [previewURL, setPreviewURLs] = useState([]);
  //states for the filter date
  const [nameOfdate, setnameOfdate] = useState({
    date: "",
    toDate: "",
    fromDate: "",
  });
  const [lastchat, setLastchat] = useState(false);
  const [time, settime] = useState("");
  const [checkedValues1, setCheckedValues1] = useState([]);
  const [checkedValues2, setCheckedValues2] = useState([]);
  const [checkedValues3, setCheckedValues3] = useState([]);
  const [checkedValues4, setCheckedValues4] = useState([]);
  const [checkedValues5, setCheckedValues5] = useState([]);
  const [checkedValues6, setCheckedValues6] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [isPreviewPageVisible, setIsPreviewPageVisible] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [selectedFilesPdf, setselectedFilesPdf] = useState([]);
  // const [chatInfo,setChatInfo] = useState({cID:null,pp:null,createByObj:null,createdAtTime:null,usersOfThatGroup:null,contact:null,description:null})
  // var conversationDataOneonOne = null;
  useEffect(() => {}, [
    checkedValues1,
    checkedValues2,
    checkedValues3,
    checkedValues4,
    checkedValues5,
    checkedValues6,
  ]);
  //media with preview page function\
  //for Previewing the selected files
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    // List of allowed image MIME types
    const allowedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/jpg",
      "image/heic",
    ];

    // Check if any selected file is not an allowed image type
    const hasNonImage = files.some(
      (file) => !allowedImageTypes.includes(file.type)
    );

    if (hasNonImage) {
      notification.error({
        message: "You are Only Allowed to upload Image",
      });

      // You can also clear the selected files here if needed
      event.target.value = null;
      return; // Exit the function if non-image files are selected
    }
    // Create an array of FileReaders to read the selected files
    const readers = files.map((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewURLs((prevPreviewURLs) => [
          ...prevPreviewURLs,
          reader.result,
        ]);
      };
      reader.readAsDataURL(file);
      return reader;
    });
    // Set the selectedFiles state after processing the files
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...files]);
  };

  const handlePdfFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles([]);
    setPreviewURLs([]);
    setimgSent(true);
    // List of allowed image MIME types

    const allowedDocumentTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
      "text/csv",
      "application/rtf",
      "application/msword",
      "application/vnd.ms-powerpoint",
      "application/vnd.ms-excel",
    ];
    const hasNonImage = files.some(
      (file) => !allowedDocumentTypes.includes(file.type)
    );

    if (hasNonImage) {
      notification.error({
        message: "You are Only Allowed to upload documents",
      });

      // You can also clear the selected files here if needed
      event.target.value = null;
      return; // Exit the function if non-image files are selected
    }
    const readers = files.map((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewURLs((prevPreviewURLs) => [
          ...prevPreviewURLs,
          reader.result,
        ]);
      };
      reader.readAsDataURL(file);
      return reader;
    });
    // Set the selectedFiles state after processing the files
    setselectedFilesPdf((prevSelectedFiles) => [
      ...prevSelectedFiles,
      ...files,
    ]);
    const selectedFileNames = files.map((file) => file.name);
    // setpdfFileName(prevSelectedFilesname => [
    // 	...prevSelectedFilesname,
    // 	...selectedFileNames,
    // ]);
    // setimgSent(false);
  };
  var arrOfMediaUrls = [];

  // function handlechat(chat) {
  // 	setIsChatOpen(true);
  // 	setUnreadFlag(false);
  // 	setOlderMessages(true);
  // 	readConversationByUSer(chatInfo.cID);
  // 	setSenderId(user._id);
  // 	setSenderName(user.name);
  // 	setnamePerson(chatInfo.contact);
  // 	setpimgLink(chatInfo.pp);
  // 	setconvoId(chatInfo.cID);
  // 	settogChat(true);
  // 	fetchChatConversation(chatInfo.cID);
  // 	setdescription(chatInfo.description);
  // 	setCreatedBy(chatInfo.createByObj);
  // 	setCreatedAt(chatInfo.createdAtTime);
  // 	setusersOfParticularGroup(chatInfo.usersOfThatGroup);
  // 	fetchConversation();
  // 	setDisplayedUsersOfGroup([]);
  // 	setIsGroupEdited(false);
  // 	setForwardCheckbox(false);
  // 	setSelectedFiles([]);
  // 	setPreviewURLs([]);
  // 	setselectedFilesPdf([]);
  // 	setIsChatOpen(true);
  // 	setSelectedMsgsForForward([]);
  // 	setSelectedMsgsForDelete([]);
  // 	setSelectedReceivedMsgs([]);
  // 	setIsPollMsgSelected([]);
  // 	setSelectedRedFlagMsgs([]);
  // 	setShowPopupClip(false);
  // 	setLastchat(true);
  // }

  //*

  const [bool, setBool] = useState(false);
  const [specConv, setSpecConv] = useState(null);

  const handleFileSelectOfPreview = async () => {
    // const files = Array.from(event.target.files);
    // setSelectedFiles(files);
    setImgpdfStatus(1);
    setimgSent(true);
    setIsPreviewPageVisible(false);
    for (const file of selectedFiles) {
      // console.log(file);
      let filenamee = file.name;
      let typeOfFile = file.type;
      let filename = filenamee;
      let mime = typeOfFile.split("/")[1];

      // console.log(filename);
      const requestBody = {
        fileName: filename,
        mime: mime,
      };
      const response = await fetch(`${apiBaseUrl}/chats/uploadPolicy`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      // console.log(data.data.fields);
      const formData = new FormData();
      
      // Set Content-Type to ensure it matches S3 policy requirements
      const contentType = file.type || "image/jpeg";
      
      for (const [key, value] of Object.entries(data.data.fields)) {
        // Override Content-Type if present to ensure exact match
        if (key.toLowerCase() === "content-type") {
          formData.set(key, contentType);
        } else {
          formData.set(key, value);
        }
      }

      // Ensure Content-Type is set even if not in fields
      if (!formData.has("Content-Type") && !formData.has("content-type")) {
        formData.set("Content-Type", contentType);
      }
      
      formData.append("file", file);
      // console.log(formData);
      const finalurl = convertS3ToCloudFront(
        `${data.data.url}/${data.filePath}`,
      );
      arrOfMediaUrls.push(finalurl);
      // console.log(finalurl);
      try {
        const almostFinalResponse = await fetch(data.data.url, {
          method: "POST",
          body: formData,
        });

        if (almostFinalResponse.ok) {
          console.log("File uploaded successfully.");
        } else {
          console.log(
            "Error occurred:",
            almostFinalResponse.status,
            almostFinalResponse.statusText
          );
        }
      } catch (error) {
        console.log("Error occurred:", error);
      }
    }
    SendMessagewithMedia(inputTextImage, convId, arrOfMediaUrls, "image");
    setIsPreviewPageVisible(false);
    setSelectedFiles([]);
    setPreviewURLs([]);
    setInputTextImage("");
    setselectedFilesPdf("");
    // setTimeout(() => {
    // 	chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    // }, 500);
    setTimeout(() => {
      setImgpdfStatus(0);
    }, 1000);
    setimgSent(false);
  };
  // preview of pdfFiles
  var arrofpdf = [];
  const handleFileSelectOfPreviewPdf = async () => {
    // const files = Array.from(event.target.files);
    // setSelectedFiles(files);
    setImgpdfStatus(1);
    setIsPreviewPageVisible(false);
    for (const file of selectedFilesPdf) {
      // console.log(file);
      let filenamee = file.name;
      let typeOfFile = file.type;
      let filename = filenamee;
      let mime = typeOfFile.split("/")[1];

      // console.log(filename);
      const requestBody = {
        fileName: filename,
        mime: mime,
      };
      const response = await fetch(`${apiBaseUrl}/chats/uploadPolicy`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      // console.log(data.data.fields);
      const formData = new FormData();
      
      // Set Content-Type to ensure it matches S3 policy requirements
      const contentType = file.type || "application/pdf";
      
      for (const [key, value] of Object.entries(data.data.fields)) {
        // Override Content-Type if present to ensure exact match
        if (key.toLowerCase() === "content-type") {
          formData.set(key, contentType);
        } else {
          formData.set(key, value);
        }
      }

      // Ensure Content-Type is set even if not in fields
      if (!formData.has("Content-Type") && !formData.has("content-type")) {
        formData.set("Content-Type", contentType);
      }
      
      formData.append("file", file);
      // console.log(formData);
      const finalurl = convertS3ToCloudFront(
        `${data.data.url}/${data.filePath}`,
      );
      arrofpdf.push(finalurl);
      // console.log(finalurl);
      try {
        const almostFinalResponse = await fetch(data.data.url, {
          method: "POST",
          body: formData,
        });

        if (almostFinalResponse.ok) {
          console.log("File uploaded successfully.");
        } else {
          console.log(
            "Error occurred:",
            almostFinalResponse.status,
            almostFinalResponse.statusText
          );
        }
      } catch (error) {
        console.log("Error occurred:", error);
      }
    }
    SendMessagewithMedia(inputTextImage, convId, arrofpdf, "image");
    setIsPreviewPageVisible(false);
    setSelectedFiles([]);
    setPreviewURLs([]);
    setInputTextImage("");
    setselectedFilesPdf("");

    setTimeout(() => {
      setImgpdfStatus(0);
    }, 1000);
  };
  //media with preview page function ends
  //Api for sending the message
  const SendMessage = async (txt, id, mentionedUserIds, replyId) => {
    try {
      const requestBody = {
        text: txt,
        id: id,
        mentionedUserId: mentionedUserIds,
      };
      if (replyId) {
        requestBody.replyId = replyId;
      }
      const response = await fetch(`${apiBaseUrl}/chats/message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();

      console.log(senderId);
      console.log({
        text: txt,
        media: [],
        sender: senderId,
        mentionedUserId: mentionedUserIds,
      });
      const messageData = {
        text: txt,
        media: [],
        sender: senderId,
        mentionedUserId: mentionedUserIds,
      };
      const socket = getSocketInstance();
      socket.emit("send_message", messageData);
      console.log("4444444444444444");

      const repliedMessage = replyId
        ? {
            sender: { name: replyMsg.name },
            text: replyMsg.text,
          }
        : null;

      setgetMsg((prevstate) => [data.message[0], ...prevstate]);

      const existingConversation = conversationdata.find(
        (conversation) => conversation._id === id
      );

      if (existingConversation) {
        // If the conversation exists in the list, move it to the top
        setConversationdata((prevData) => {
          const newData = prevData.filter(
            (conversation) => conversation._id !== id
          );
          return [existingConversation, ...newData];
        });
      } else {
        // If the conversation doesn't exist in the list, fetch the updated conversation data
        fetchConversation();
      }

      if (data.success) {
        // Assume you have an array of FCM tokens named fcmTokensArray
        const fcmTokens = data.fcmTokensArray; // Replace with your actual array
        const mediaLength = data.message[0].media.length;
        const bodyText =
          mediaLength !== 0
            ? `Media ${mediaLength} ${data.message[0].text}`
            : data.message[0].text;
        console.log(bodyText);
        // Create the body for the FCM notification
        const fcmRequestBody = {
          registration_ids: fcmTokens,
          notification: {
            body: bodyText,
            OrganizationId: "2",
            content_available: true,
            priority: "high",
            subtitle: "",
            title: `${data.senderName.name} - ${data.conversations.name}`,
          },
          priority: "high",
          data: {
            priority: "high",
            sound: "app_sound.wav",
            content_available: true,
            bodyText: "New Announcement assigned",
            organization: "Elementary school",
          },
        };

        // Call the FCM API using fetch
        const fcmResponse = await fetch("https://fcm.googleapis.com/fcm/send", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization:
              "KEY=AAAADZRKCno:APA91bEIVDZfaU1X4Bs3o6K8L4C8zXZ6DwIOaZ43iAfHIwNHwL27_6oY_4KO7qBBBvc4_I1TktUbZOQC30x1d7n2CB1JBulEprLrgRXmklUdxDHb17NNN6KgCK0jXYxXwCjldVjNjeNr",
          },
          body: JSON.stringify(fcmRequestBody),
        });

        // Handle the FCM response if needed
        const fcmData = await fcmResponse.json();
        console.log("FCM API response:", fcmData);

        if (data.mentionedTokens.length !== 0) {
          const fcmTokens = data.mentionedTokens; // Replace with your actual array
          const mediaLength = data.message[0].media.length;
          const bodyText =
            mediaLength !== 0
              ? `Media ${mediaLength} ${data.message[0].text}`
              : data.message[0].text;
          console.log(bodyText);
          // Construct the body for the second API call with mentionedTokens
          const secondApiRequestBody = {
            registration_ids: fcmTokens,
            notification: {
              body: "Mentioned You - " + bodyText,
              OrganizationId: "2",
              content_available: true,
              priority: "high",
              subtitle: "",
              title: `${data.senderName.name} - ${data.conversations.name}`,
            },
            priority: "high",
            data: {
              priority: "high",
              sound: "app_sound.wav",
              content_available: true,
              bodyText: "New Announcement assigned",
              organization: "Elementary school",
            },
          };

          // Call the second API using fetch
          const secondApiResponse = await fetch(
            "https://fcm.googleapis.com/fcm/send",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization:
                  "KEY=AAAADZRKCno:APA91bEIVDZfaU1X4Bs3o6K8L4C8zXZ6DwIOaZ43iAfHIwNHwL27_6oY_4KO7qBBBvc4_I1TktUbZOQC30x1d7n2CB1JBulEprLrgRXmklUdxDHb17NNN6KgCK0jXYxXwCjldVjNjeNr",
              },
              body: JSON.stringify(secondApiRequestBody),
            }
          );

          // Handle the second API response if needed
          const secondApiData = await secondApiResponse.json();
          console.log("Second API response:", secondApiData);
        }
      }

      setReloadFlag(true);
    } catch (error) {
      console.log("Some error occurred", error);
    }
  };
  const SendMessagewithMedia = async (txt, id, url, type, mentionedUserIds) => {
    try {
      // const samp = [];
      // samp.push(url);
      // alert("calle");
      var text = "";
      if (txt === null || txt === undefined || txt === "") {
        text = " ";
      } else {
        text = txt;
      }
      // console.log(url);
      const requestBody = {
        text: text,
        id: id,
        files: url,
        mime: type,
        mentionedUserId: mentionedUserIds,
      };
      const response = await fetch(`${apiBaseUrl}/chats/message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      url = url.map((ele) => {
        return {
          url: ele,
        };
      });

      setReloadFlag(true);
      setSelectedFiles([]);
      setPreviewURLs([]);
      setInputTextImage("");
      setselectedFilesPdf("");
      setIsPreviewPageVisible(false);
      if (data.success) {
        // Assume you have an array of FCM tokens named fcmTokensArray
        const fcmTokens = data.fcmTokensArray; // Replace with your actual array
        const mediaLength = data.message[0].media.length;
        const bodyText =
          mediaLength !== 0
            ? `Media ${mediaLength} ${data.message[0].text}`
            : data.message[0].text;
        console.log(bodyText);
        // Create the body for the FCM notification
        const fcmRequestBody = {
          registration_ids: fcmTokens,
          notification: {
            body: bodyText,
            OrganizationId: "2",
            content_available: true,
            priority: "high",
            subtitle: "",
            title: `${data.senderName.name} - ${data.conversations.name}`,
          },
          priority: "high",
          data: {
            priority: "high",
            sound: "app_sound.wav",
            content_available: true,
            bodyText: "New Announcement assigned",
            organization: "Elementary school",
          },
        };

        // Call the FCM API using fetch
        const fcmResponse = await fetch("https://fcm.googleapis.com/fcm/send", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization:
              "KEY=AAAADZRKCno:APA91bEIVDZfaU1X4Bs3o6K8L4C8zXZ6DwIOaZ43iAfHIwNHwL27_6oY_4KO7qBBBvc4_I1TktUbZOQC30x1d7n2CB1JBulEprLrgRXmklUdxDHb17NNN6KgCK0jXYxXwCjldVjNjeNr",
          },
          body: JSON.stringify(fcmRequestBody),
        });

        // Handle the FCM response if needed
        const fcmData = await fcmResponse.json();
        console.log("FCM API response:", fcmData);

        if (data.mentionedTokens.length !== 0) {
          const fcmTokens = data.mentionedTokens; // Replace with your actual array
          const mediaLength = data.message[0].media.length;
          const bodyText =
            mediaLength !== 0
              ? `Media ${mediaLength} ${data.message[0].text}`
              : data.message[0].text;
          console.log(bodyText);
          // Construct the body for the second API call with mentionedTokens
          const secondApiRequestBody = {
            registration_ids: fcmTokens,
            notification: {
              body: "Mentioned You - " + bodyText,
              OrganizationId: "2",
              content_available: true,
              priority: "high",
              subtitle: "",
              title: `${data.senderName.name} - ${data.conversations.name}`,
            },
            priority: "high",
            data: {
              priority: "high",
              sound: "app_sound.wav",
              content_available: true,
              bodyText: "New Announcement assigned",
              organization: "Elementary school",
            },
          };

          // Call the second API using fetch
          const secondApiResponse = await fetch(
            "https://fcm.googleapis.com/fcm/send",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization:
                  "KEY=AAAADZRKCno:APA91bEIVDZfaU1X4Bs3o6K8L4C8zXZ6DwIOaZ43iAfHIwNHwL27_6oY_4KO7qBBBvc4_I1TktUbZOQC30x1d7n2CB1JBulEprLrgRXmklUdxDHb17NNN6KgCK0jXYxXwCjldVjNjeNr",
              },
              body: JSON.stringify(secondApiRequestBody),
            }
          );

          // Handle the second API response if needed
          const secondApiData = await secondApiResponse.json();
          console.log("Second API response:", secondApiData);
        }
      }
    } catch (error) {
      console.log("Some error occurred");
    }
  };
  //Api for sending the message end
  const SendMessagePoll = async (msgid, question, options) => {
    try {
      const requestBody = {
        id: msgid,
        text: "Poll added by vanhsita",

        poll: {
          question: question,
          options: options,
        },
      };
      const response = await fetch(`${apiBaseUrl}/chats/message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      fetchChatConversation(msgid);
    } catch (error) {
      console.log("Some error occurred");
    }
  };
  const handleFormSubmit = async (event) => {
    setIsLoading(true);
    settog(true);

    event.preventDefault();
    const trueKeys = Object.entries(standardfilter)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    const trueKeys2 = Object.entries(batchfilter)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    const trueKeys3 = Object.entries(branchfilter)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    const trueKeys4 = Object.entries(subjectfilter)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    const trueKeys5 = Object.entries(level)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    const trueKeys6 = Object.entries(boardsfilter)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    const trueKeys7 = Object.entries(schoolFilter)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    const trueKeys8 = Object.entries(programFilter)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key);
    try {
      const params = new URLSearchParams();
      // console.log(checkedValues1);
      trueKeys.forEach((item) => {
        params.append("std[]", item);
      });
      trueKeys2.forEach((item) => {
        params.append("batch[]", item);
      });
      trueKeys3.forEach((item) => {
        params.append("queryPhase[]", item);
      });
      trueKeys4.forEach((item) => {
        params.append("subject[]", item);
      });
      trueKeys5.forEach((item) => {
        params.append("levels[]", item);
      });
      trueKeys6.forEach((item) => {
        params.append("board[]", item);
      });
      trueKeys7.forEach((item) => {
        params.append("schoolName[]", item);
      });
      trueKeys8.forEach((item) => {
        params.append("queryPhase[]", item);
      });
      // params.append("fromDate", nameOfdate.fromDate);
      // params.append("toDate", nameOfdate.toDate);
      if (
        trueKeys.length === 0 &&
        trueKeys2.length === 0 &&
        trueKeys3.length === 0 &&
        trueKeys4.length === 0 &&
        trueKeys5.length === 0 &&
        trueKeys6.length === 0 &&
        trueKeys7.length === 0 &&
        trueKeys8.length === 0 &&
        checked.timeOpt != 0
      ) {
        fetchAcctoTimeOnly();
        return;
      } else if (
        (trueKeys.length === 0 &&
          trueKeys2.length === 0 &&
          trueKeys3.length === 0 &&
          trueKeys4.length === 0 &&
          trueKeys5.length === 0 &&
          trueKeys6.length === 0 &&
          trueKeys7.length === 0 &&
          trueKeys8.length === 0 &&
          nameOfdate.date != "") ||
        (nameOfdate.fromDate != "" && nameOfdate.toDate != "")
      ) {
        // console.log(nameOfdate.date, nameOfdate.toDate, nameOfdate.fromDate);
        fetchChatsAccToDate();
        return;
      }
      if (checked.timeOpt != 0) {
        params.append("time", checked.timeOpt);
      }
      if (
        nameOfdate.date != "" ||
        (nameOfdate.fromDate != "" && nameOfdate.toDate != "")
      ) {
        if (nameOfdate.date != "") {
          params.append("date", nameOfdate.date);
        } else {
          params.append("fromDate", nameOfdate.fromDate);
          params.append("toDate", nameOfdate.toDate);
        }
      }
      if (params.toString() === "") {
        // The URLSearchParams instance is empty
        fetchConversation(1);
      } else {
        // The URLSearchParams instance is not empty
        const response = await fetch(
          `${apiBaseUrl}/chats/filteredConversations?${params.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${window.localStorage.getItem("token")}`,
            },
          }
        );
        // ${apiBaseUrl}/chats/message

        const data = await response.json();
        if (data.success) {
          setConversationdata(data.conversations);
        } else {
          setConversationdata([]);
        }
      }

      setIsLoading(false);
      // console.log(data.conversations);
    } catch (error) {
      console.log("Some error occurred");
    }
  };

  //Sates for the filter time
  // const [timeSelected, settimeSelected] = useState("");
  // Api for the only time starts
  const fetchAcctoTimeOnly = async () => {
    try {
      const params = new URLSearchParams();
      console.log(checked.timeOpt);
      params.append("time", checked.timeOpt);
      const response = await fetch(
        `${apiBaseUrl}/chats/filteredTime?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );

      const data = await response.json();
      if (data.success) {
        setConversationdata(data.conversations); //this point
      } else {
        setConversationdata([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Some error occurred");
    }
  };
  //Api for only thime ends
  const fetchConversation = async (count) => {
    if (conversationdata && conversationdata.length === 0) {
      setIsLoading(true);
    }

    try {
      const response = await fetch(`${apiBaseUrl}/chats/conversation`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      });
      const data = await response.json();
      // setConversationdata(data.conversations); //this point
      setConversationdata((prevConversations) => {
        // If conversationdata is empty, load all conversations
        if (prevConversations.length === 0 || count == 1) {
          console.log("Empty conversations");
          return data.conversations;
        }

        // Update conversations with matching _id
        const updatedConversations = prevConversations.map((prevConv) => {
          const newConv = data.conversations.find(
            (newConv) => newConv._id === prevConv._id
          );
          return newConv || prevConv;
        });
        return updatedConversations;
      });
      // console.log(data.conversations);
      setIsLoading(false);
    } catch (error) {
      console.log("Some error occurred");
    }
  };
  const readConversationByUSer = async (conversationId) => {
    // console.log('called');
    const params = new URLSearchParams();
    params.append("id", conversationId);
    const response = await fetch(
      `${apiBaseUrl}/chats/conversation/opened?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // API call succeeded, update UI accordingly
          console.log("success");
        } else {
          // API call failed, handle the error
          console.error(
            "Error marking/unmarking message as red flag:",
            data.msg
          );
        }
      })
      .catch((error) => {
        console.error("Error marking/unmarking message as red flag:", error);
      });
  };

  async function fetchChatConversation(id) {
    try {
      setgetMsg([]);
      let url = `${apiBaseUrl}/chats/conversation/get?id=${id}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      });

      const data = await response.json();
      // console.log(data);
      setsampledataa(data);
      setIsSend(true);
      setsender_id(data.messages[0].sender._id);
      setgetMsg(data.messages);
      if (allUsers.length === 0) {
        getUsers();
      }
    } catch (error) {
      console.log("Error:", error.message);
    }
  }

  //fetch chat according to date api only when only date is passed
  async function fetchChatsAccToDate(e) {
    const params = new URLSearchParams();
    if (nameOfdate.date != "") {
      params.append("date", nameOfdate.date);
    } else {
      params.append("fromDate", nameOfdate.fromDate);
      params.append("toDate", nameOfdate.toDate);
    }

    try {
      const response = await fetch(
        `${apiBaseUrl}/chats/filteredDate?${params.toString()}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        setConversationdata(data.conversations);
      } else {
        setConversationdata([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
    }
  }

  // onchange function for date
  const onChange = (e) => {
    setnameOfdate({ ...nameOfdate, [e.target.name]: e.target.value });
    const dateValue = e.target.value;
    setSelectedDate(dateValue);
  };
  // onchange function for date end
  // Api to fetch conversation acc to all filters
  // Api to fetch conversation acc to all filters
  //fetch chat according to date api only when only date is passed end
  // from here it is the ending of context API
  var count = 0;
  const [checked, setchecked] = useState({
    timeOpt: 0,
  });
  //    Array of object to check the name of filter
  const [nameOfFilter, setnameOfFilter] = useState({ name: "Time" });
  const [namePerson, setnamePerson] = useState("username");
  const [conversationId, setconversationId] = useState("");
  const [first, setfirst] = useState("second");
  const [pimgLink, setpimgLink] = useState(
    "https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/628c8d587640243d911a71d4/kbVumlrcT6.svg"
  );
  // Api for integrating media starts
  const uploadMedia = async () => {
    try {
      let filename = mediaDetails.filename;
      let mime = mediaDetails.type.split("/")[1];
      console.log(filename);
      const requestBody = {
        fileName: filename,
        mime: mime,
      };
      console.log(mediaDetails.type.split("/")[1]);
      const response = await fetch(`${apiBaseUrl}/chats/uploadPolicy`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      // console.log(data.data.fields);
    } catch (error) {
      console.log("Some error occurred");
    }
  };
  // Api for integrating media ends

  // Api for broadcast message
  async function handleBroadcast(filesbroadcast, broadcastMsgFor) {
    try {
      const requestBody = {
        conversations: selectedConversations,
        text: broadcastMsg,
        files: filesbroadcast,
        mime: "image",
        msgFor: broadcastMsgFor !== "All" && broadcastMsgFor,
      };
      const response = await fetch(`${apiBaseUrl}/chats/broadcastMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.success == true) {
        notification.success({ message: "Message Broadcasted Successfully " });
      }
      // console.log('broadcast called');
      setBroadcastMsg("");
      setSelectedConversations([]);
      setBroadcastMsg([]);
    } catch (error) {
      console.log("Error: ", error.message);
    }
  }

  //api for creating custom shortcut
  async function handleCustomFilter() {
    try {
      const requestBody = {
        conversations: selectedConversations,
        createdBy: user._id,
        name: customFilterName,
        shortName: customFilterShortName,
      };
      const response = await fetch(`${apiBaseUrl}/chats/createShortcut`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.success) {
        setSelectedConversations([]);
        setCustomFilterName("");
        setCustomFilterShortName("");
        getShortcuts();
      }
    } catch (error) {
      console.log("Error: ", error.message);
    }
  }

  //api for getting shortcuts
  async function getShortcuts() {
    try {
      const response = await fetch(`${apiBaseUrl}/chats/getUserShortcuts`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      });
      const data = await response.json();
      if (data.success == true) {
        data.shortcuts.map((shortcut, i) => {
          if (shortcut._id === shortcutId) {
            setShortcutConv(shortcut.conversation);
            notification.success({ message: "Shortcut edited successfully!" });
            setSelectedConversations([]);
          }
        });
      }
      // console.log(data);
      setCustomShortcutdata(data.shortcuts);
    } catch (error) {
      console.log("Error: ", error.message);
    }
  }

  //api for deleting shortcut
  async function deleteShortcut() {
    try {
      const requestBody = {
        shortcutId: shortcutId,
      };
      const response = await fetch(`${apiBaseUrl}/chats/deleteShortcut`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.success) {
        getShortcuts();
        notification.success({ message: "Shortcut deleted successfully!" });
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  //api for adding conversation to shortcut
  async function addConvToShortcut() {
    try {
      const requestBody = {
        conversationIds: selectedConversations,
        shortcutId: shortcutId,
      };
      const response = await fetch(
        `${apiBaseUrl}/chats/addConversationToShortcut`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      if (data.success == true) {
        getShortcuts();
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  //api for removing a conversation from shortcut
  async function deleteConvFromShortcut() {
    try {
      const requestBody = {
        conversationIds: selectedConversations,
        shortcutId: shortcutId,
      };
      const response = await fetch(
        `${apiBaseUrl}/chats/deleteConversationsFromShortcut`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );
      if (response) {
        getShortcuts();
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function getUsers() {
    setIsLoading1(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/chats/get-users?phase=${phaseId}&clientId=${clientId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) setAllUsers(data.users);
      else setAllUsers([]);
      setIsLoading1(false);
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function createGroup() {
    try {
      const requestBody = {
        users: selectedUsers,
        isGroup: true,
        name: groupName,
        description: groupDesc,
      };
      const response = await fetch(`${apiBaseUrl}/chats/conversation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.success == true) {
        setGroupDesc("");
        setGroupName("");
        notification.success({ message: "Group is created!" });
        fetchConversation();
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }
  async function createOneOnOneChat() {
    try {
      const requestBody = {
        users: selectedUsers,
        isGroup: true,
        name: groupName,
        description: "ONE To ONE Chat", //Dont change this description ...its very crucial for backend
        oneToOne: true,
      };
      const response = await fetch(`${apiBaseUrl}/chats/conversation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.success == true) {
        // setGroupDesc('');
        setGroupName("");
        notification.success({ message: " is created!" });
        await fetchConversation(1);
        setBool(true);
        setSpecConv(data.id);
      }
      return;
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function addUserToGrp() {
    try {
      const response = await fetch(
        `${apiBaseUrl}/chats/conversation/group/add-user?id=${convId}&user=${selectedUser}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      // console.log(data);
      if (response) {
        notification.success({ message: "User Added Successfully!" });
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function removeUserFromGrp(userId, isExitGrp) {
    try {
      const response = await fetch(
        `${apiBaseUrl}/chats/conversation/group/remove-user?id=${convId}&user=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        if (isExitGrp) {
          setConversationdata(
            conversationdata.filter(
              (conversation) => conversation._id != convId
            )
          );
          setIsChatOpen(false);
          notification.success({
            message: "You exited the group successfully",
          });
        } else {
          setSelectedUser("");
          notification.success({ message: "User Removed Successfully!" });
        }
      } else {
        notification.error(data.msg);
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function makeGroupAdmin() {
    try {
      const response = await fetch(
        `${apiBaseUrl}/chats/conversation/admin/assign?id=${convId}&user=${selectedUser}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      // console.log(data);
      if (response) {
        setSelectedUser("");
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function removeAsAdmin() {
    try {
      const response = await fetch(
        `${apiBaseUrl}/chats/conversation/admin/remove?id=${convId}&user=${selectedUser}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      // console.log(data);
      if (response) {
        setSelectedUser("");
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function forwardMessage() {
    try {
      const requestBody = {
        conversationIds: selectedConversations,
        messageIds: selectedMsgsForForward,
      };
      const response = await fetch(`${apiBaseUrl}/chats/forwardMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.success) {
        notification.success({ message: "Message sent successfully!" });
        setSelectedConversations([]);
        // setSelectedMsgs([]);
        setSelectedMsgsForForward([]);
        setSelectedMsgsForDelete([]);
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  const markAsDelete = (cId) => {
    fetch(`${apiBaseUrl}/chats/message/delete`, {
      method: "POST",
      body: JSON.stringify({
        messages: selectedMsgsForDelete,
      }),
      headers: {
        "Content-Type": "application/json",
        authorization: `Token ${window.localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setMsgDeleted(true);
        setgetMsg(
          getMsg.filter((msg) => !selectedMsgsForDelete.includes(msg._id))
        );
        if (selectedMsgsForDelete.length > 1) {
          notification.success({ message: "Messages deleted successfully" });
        } else {
          notification.success({ message: "Message deleted successfully" });
        }
        setSelectedMsgs([]);
        setSelectedMsgsForForward([]);
        setSelectedMsgsForDelete([]);
        setReloadFlag(true);
      });
  };

  const markAsUnsend = (cId) => {
    console.log(selectedMsgsForDelete);
    fetch(`${apiBaseUrl}/chats/message/unsend`, {
      method: "POST",
      body: JSON.stringify({
        messages: selectedMsgsForDelete,
      }),
      headers: {
        "Content-Type": "application/json",
        authorization: `Token ${window.localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        // const msgs = getMsg.filter(msg => !selectedMsgsForDelete.includes(msg._id));
        const msgs = getMsg.map((msg) => {
          if (selectedMsgsForDelete.includes(msg._id)) {
            return { ...msg, text: "🚫 This message was deleted." };
          }
          return msg;
        });
        setgetMsg(msgs);
        setMsgDeleted(true);
        setgetMsg(
          getMsg.filter((msg) => !selectedMsgsForDelete.includes(msg._id))
        );
        if (selectedMsgsForDelete.length > 1) {
          notification.success({ message: "Messages deleted successfully" });
        } else {
          notification.success({ message: "Message deleted successfully" });
        }
        // setSelectedMsgs([]);
        setSelectedMsgsForForward([]);
        setSelectedMsgsForDelete([]);
        setReloadFlag(true);
      });
  };

  async function addUsersToMultipleGroup() {
    try {
      const requestBody = {
        usersToAddArray: selectedUsers,
        conversations: selectedConversations,
      };
      const response = await fetch(
        `${apiBaseUrl}/chats/addMultipleUsersInMultipleGroup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      if (data.success == true) {
        notification.success({ message: "Users are added successfully!" });
        setSelectedUsers([]);
        setSelectedConversations([]);
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function updateConversationDescription(
    conversationId,
    userId,
    updatedGroupInfo
  ) {
    try {
      const requestBody = {
        convId: conversationId,
        userId: userId,
        description: updatedGroupInfo,
      };
      const response = await fetch(
        `${apiBaseUrl}/chats/updateConversationDescription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      console.log(data);
      if (data.success == true) {
        notification.success({ message: "Description updated successfully!" });
        setdescription(data.conversation.description);
      }
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }

  async function mediaPreview() {
    try {
      const response = await fetch(
        `${apiBaseUrl}/chats/getPreviewOfImagesAndDocuments?convId=${convId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        setPreviewMedia(data.PreviewMedia);
      }
      console.log(data);
    } catch (error) {
      console.log("Some error occured: ", error.message);
    }
  }
  async function readbyNames(msgId) {
    const requestBody = {
      msgId: msgId,
    };
    const response = await fetch(`${apiBaseUrl}/chats/readByMsgs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Token ${window.localStorage.getItem("token")}`,
      },
      body: JSON.stringify(requestBody),
    });
    const data = await response.json();
    // console.log("data",data.data)

    setReadByArray(data.data);
    return data.data;
  }

  async function makeAdminInMultipleGrps() {
    const requestBody = {
      conversations: selectedConversations,
      user: selectedUser,
    };
    const response = await fetch(
      `${apiBaseUrl}/chats/makeAdminInMultipleGroups`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      }
    );
    const data = await response.json();
    setSelectedConversations([]);
    setSelectedUser("");
    if (data.success) {
      notification.success({ message: "User has admin access now " });
    }
  }

  async function getCustomFilters() {
    const response = await fetch(
      `${apiBaseUrl}/chats/getCustomFilterData?client=${clientId}`,
      {
        method: "GET",

        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      }
    );

    const data = await response.json();
    console.log(data.data);
    setCustomFilterData(data.data);
  }
  function chatName(chat) {
    if (chat.users.length === 2 && userId && chat.oneToOneCount) {
      let data = chat.users.filter((ele) => ele.user?._id != userId);
      return data[0].user?.username;
    } else {
      return chat.name;
    }
  }
  // const [active, setactive] = useState(true);
  return (
    <filterContext.Provider
      value={{
        schoolFilter,
        programFilter,
        setProgramFilter,
        setSchoolFilter,
        chatName,
        chatSelected,
        setChatSelected,
        bool,
        specConv,
        setSpecConv,
        setBool,
        first,
        checked,
        setchecked,
        nameOfFilter,
        setnameOfFilter,
        count,
        namePerson,
        setnamePerson,
        pimgLink,
        setpimgLink,
        conversationId,
        setconversationId,
        fetchChatConversation,
        getMsg,
        setgetMsg,
        setsender_id,
        sender_id,
        fetchChatsAccToDate,
        nameOfdate,
        setnameOfdate,
        onChange,
        conversationdata,
        setConversationdata,
        fetchConversation,
        handleFormSubmit,
        standardfilter,
        setstandardfilter,
        level,
        setlevel,
        batchfilter,
        setbatchfilter,
        branchfilter,
        setbranchfilter,
        boardsfilter,
        setboardsfilter,
        subjectfilter,
        setsubjectfilter,
        time,
        settime,
        fetchAcctoTimeOnly,
        tog,
        createOneOnOneChat,
        settog,
        togChat,
        settogChat,
        description,
        setdescription,
        usersOfParticularGroup,
        setusersOfParticularGroup,
        SendMessage,
        reloadFlag,
        setReloadFlag,
        staticGetMsg,
        setstaticGetMsg,
        convId,
        setconvoId,
        selectedDate,
        setSelectedDate,
        mediaDetails,
        setmediaDetails,
        uploadMedia,
        SendMessagewithMedia,
        sampledataa,
        setsampledataa,
        SendMessagePoll,
        selectedConversations,
        setSelectedConversations,
        handleCustomFilter,
        customFilterName,
        setCustomFilterName,
        customFilterShortName,
        setCustomFilterShortName,
        handleBroadcast,
        broadcastMsg,
        setBroadcastMsg,
        filter,
        setfilter,
        getShortcuts,
        customShortcutData,
        shortcutId,
        setShortcutId,
        deleteShortcut,
        addConvToShortcut,
        deleteConvFromShortcut,
        senderId,
        senderName,
        setSenderId,
        setSenderName,
        unreadFlag,
        setUnreadFlag,
        allUsers,
        getUsers,
        selectedUser,
        setSelectedUser,
        addUserToGrp,
        displayedUsersOfGroup,
        setDisplayedUsersOfGroup,
        removeUserFromGrp,
        adminsOfParticularGrp,
        setAdminsOfParticularGrp,
        setIsGroupEdited,
        isGrpEdited,
        makeGroupAdmin,
        removeAsAdmin,
        isLoading,
        isLoading1,
        selectedUsers,
        setSelectedUsers,
        setGroupDesc,
        setGroupName,
        groupDesc,
        groupName,
        createGroup,
        selectedMsgs,
        setSelectedMsgs,
        forwardCheckbox,
        setForwardCheckbox,
        forwardMessage,
        replyId,
        setReplyId,
        replyMsg,
        setReplyMsg,
        broadurls,
        setBroadurls,
        setFlagScroll,
        flagScroll,
        selectedReceivedMsgs,
        setSelectedReceivedMsgs,
        markAsDelete,
        markAsUnsend,
        shortcutConv,
        setShortcutConv,
        isSend,
        setIsSend,
        isChatLoading,
        setIsChatLoading,
        isSocketReceived,
        setIsSocketReceived,
        readConversationByUSer,
        selectedFiles,
        setSelectedFiles,
        previewURL,
        setPreviewURLs,
        handleFileSelectOfPreview,
        handleFileChange,
        inputTextImage,
        setInputTextImage,
        isPreviewPageVisible,
        setIsPreviewPageVisible,
        handlePdfFileChange,
        isChatOpen,
        setIsChatOpen,
        selectedFilesPdf,
        setselectedFilesPdf,
        fileSelect,
        setfileSelect,
        pstate,
        setpstate,
        isPollMsgSelected,
        setIsPollMsgSelected,
        createdBy,
        setCreatedBy,
        createdAt,
        setCreatedAt,
        selectedRedFlagMsgs,
        setSelectedRedFlagMsgs,
        schoolFilter,
        setSchoolFilter,
        activeDropdownMsgId,
        setActiveDropdownMsgId,
        pdfFileName,
        setpdfFileName,
        imgSent,
        setimgSent,
        showPopupClip,
        setShowPopupClip,
        imgpdfstatus,
        setImgpdfStatus,
        handleFileSelectOfPreviewPdf,
        resetAllFilter,
        selectedMsgsForForward,
        setSelectedMsgsForForward,
        selectedMsgsForDelete,
        setSelectedMsgsForDelete,
        olderMessages,
        setOlderMessages,
        lastchat,
        setLastchat,
        showRedFlagResolution,
        setShowRedFlagResolution,
        msgDeleted,
        setMsgDeleted,
        addUsersToMultipleGroup,
        updateConversationDescription,
        mediaPreview,
        previewMedia,
        setPreviewMedia,
        readbyNames,
        readByArray,
        setReadByArray,
        makeAdminInMultipleGrps,
        getCustomFilters,
        customFilterData,
      }}
    >
      {props.children}
    </filterContext.Provider>
  );
};

export default FilterState;
